import {
  FILING_GROUP_LABELS,
  FILING_GROUP_ORDER,
  FilingGroup,
} from "v2/constants/filingGroup";
import { FilingNode } from "v2/types/filingsDashboard.types";

const withLastFlag = (filings: FilingNode[]): FilingNode[] =>
  filings.map((filing, index) => ({
    ...filing,
    isLast: index === filings.length - 1,
  }));

const toGroupNode = (
  group: FilingGroup,
  filings: FilingNode[],
  season: string
): FilingNode => ({
  id: `${season}-${group}`,
  title: FILING_GROUP_LABELS[group],
  group,
  season,
  paymentAmount: 0,
  isGroupRow: true,
  subRows: withLastFlag(filings),
});

export const nestFilingsByGroup = (
  filings: FilingNode[],
  season: string
): FilingNode[] =>
  FILING_GROUP_ORDER.map((group) => ({
    group,
    filings: filings.filter((filing) => filing.group === group),
  }))
    .filter(({ filings: grouped }) => grouped.length > 0)
    .map(({ group, filings: grouped }) => toGroupNode(group, grouped, season));
